/** Ground rule §3.2 — the one unobtrusive "simulated" indicator, used everywhere a simulated integration is shown.
 *  Styled in the design's micro-label grammar (9px / 0.11em caps / var(--muted2)); never louder than the content it labels. */
export interface SimulatedBadgeProps {
  /** What is simulated, e.g. "broker", "market data", "AI". Rendered as a title and in the label. */
  what: string;
  /** Compact renders only the dot + "SIM"; default renders "simulated · what". */
  compact?: boolean;
}
export function SimulatedBadge({ what, compact = false }: SimulatedBadgeProps) {
  return (
    <span
      data-simulated={what}
      title={`Simulated ${what} — deterministic, seeded demo behaviour, not a live integration`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        fontSize: '9px',
        letterSpacing: '0.11em',
        textTransform: 'uppercase',
        color: 'var(--muted2)',
        fontWeight: 600,
        padding: '2px 7px',
        borderRadius: '99px',
        border: '1px solid var(--l8)',
        whiteSpace: 'nowrap',
      }}
    >
      <span
        aria-hidden="true"
        style={{ width: '5px', height: '5px', borderRadius: '50%', background: 'var(--amb)' }}
      />
      {compact ? 'SIM' : `simulated · ${what}`}
    </span>
  );
}
